import React from "react";
import { observer, inject } from "mobx-react";
import { Redirect } from "react-router-dom";

export default WrappedComponent => {
  class ProtectedComponent extends React.Component {
    render() {
      const {
        rootStore: { authStore }
      } = this.props;
      if (authStore.loggedIn) {
        return <WrappedComponent {...this.props} />;
      } else {
        return <Redirect to={{ pathname: "/login", state: { from: this.props.location } }} />;
      }
    }
  }

  return inject("rootStore")(observer(ProtectedComponent));
};
